const price = contractPlanEntry => {
  if (!contractPlanEntry || contractPlanEntry.length === 0) return 0

  return Math.abs(contractPlanEntry[0].price)
}

export default price
